
import React from 'react';
import { Switch, Route } from 'react-router-dom';
// sc-order
import Order from '../sc-order/Order';
import OrderCreate from '../sc-order/Order/OrderCreate';

import OrderDetails from '../sc-order/Order/Details';
import PageNotFound from '../sc-notFound'
// sc-myProfile
import MyProfile from '../sc-profile/ProfileViewTabs';
import DefaultTypicalProblem from '../sc-profile/YourSettings/TypicalProblems';

// sc-user
import User from '../sc-users/User';
import UserDetails from '../sc-users/User/UserDetails';
import UserCreate from '../sc-users/User/UserCreate';
// sc-licensePrototypes
import LicensePrototype from '../sc-licensePrototype/LicensePrototype';
import LicensePrototypeEdit from '../sc-licensePrototype/LicensePrototype/LicensePrototypeEdit';
import LicensePrototypeCreate from '../sc-licensePrototype/LicensePrototype/LicensePrototypeCreate';

// sc-customer
import CustomerList from '../sc-customer/Customer';
import CustomerCreate from '../sc-customer/Customer/CustomerCreate.js';
import CustomerEdit from '../sc-customer/Customer/Details';
// sc-admin
import ErrorLog from "../sc-admin/ErrorLog";
import TableView from '../sc-admin/TableView';
import TableViewCreate from '../sc-admin/TableView/TableViewCreate';
import TableViewEdit from '../sc-admin/TableView/TableViewEdit';
import ProductType from '../sc-admin/ProductType';
import ProductTypeCreate from '../sc-admin/ProductType/ProductTypeCreate';
import ProductTypeEdit from '../sc-admin/ProductType/ProductTypeEdit';
import SystemCertificate from '../sc-admin/SystemCertificate';
import SystemCertificateEdit from '../sc-admin/SystemCertificate/SystemCertificateEdit';
import SystemCertificateCreate from '../sc-admin/SystemCertificate/SystemCertificateCreate';
import UserAdminSettings from '../sc-admin/UserAdminSettings/User';

// import RestClient from './RestClient';
import ExternalSystemSetting from "../sc-externalSystemSettings/ExternalSystemSetting";
import ExternalSystemSettingCreate from '../sc-externalSystemSettings/ExternalSystemSetting/ExternalSystemSettingCreate';
import ExternalSystemSettingEdit from '../sc-externalSystemSettings/ExternalSystemSetting/ExternalSystemSettingEdit';
import DeliveryNotes from "../sc-admin/DeliveryNotes";
import IntegrityCheck from "../sc-admin/IntegrityCheck";
import Translate from "../sc-translate/Translate";
import TranslateCreate from "../sc-translate/Translate/TranslateCreate";
import TranslateEdit from "../sc-translate/Translate/TranslateEdit";
import TranslationUpload from "../sc-translate/Translate/TranslationUpload";
import GradingCategory from "../sc-admin/GradingCategory";
import GradingCategoryCreate from '../sc-admin/GradingCategory/GradingCategoryCreate';
import GradingCategoryEdit from '../sc-admin/GradingCategory/GradingCategoryEdit';

import Permission from '../sc-admin/Permission';
import PermissionEdit from '../sc-admin/Permission/PermissionEdit';
import PermissionCreate from '../sc-admin/Permission/PermissionCreate';
import PermissionUpload from '../sc-admin/Permission/PermissionUpload';
import SentMail from "../sc-admin/SentMail";
import ErasureMethod from '../sc-admin/ErasureMethod';
import ErasureMethodCreate from '../sc-admin/ErasureMethod/ErasureMethodCreate';
import ErasureMethodEdit from '../sc-admin/ErasureMethod/ErasureMethodEdit';

// sc-report
import ErasureReportTabs from "../sc-reports/ErasureReport";
import DiagnoseReport from '../sc-reports/DiagnoseReport';
import VerificationReport from '../sc-reports/VerificationReport';

// sc-printQueues
import PrintQueueList from '../sc-printQueue/PrintQueue';
// sc-serverInstance
import ServerInstanceList from '../sc-serverInstance/ServerInstance';
// sc-dashboard
import Overview from '../sc-dashboard/Overview';
import Report from '../sc-dashboard/Report';
import Statistic from '../sc-dashboard/Statistic';
import ProductOverview from '../sc-dashboard/ProductOverview';
import AllProducts from '../sc-allProducts';
import Search from '../sc-dashboard/Search';
import RemoteAssets from '../sc-dashboard/RemoteAssets';
import UploadErasureData from '../sc-dashboard/UploadErasureData';

// sc-settings
import OperatingSystemCreate from '../sc-settings/OperatingSystem/OperatingSystemCreate';
import OperatingSystemEdit from '../sc-settings/OperatingSystem/OperatingSystemEdit';

import Grading from '../sc-settings/Grading';

import GradeCreate from '../sc-settings/Grade/GradeCreate';
import GradeEdit from '../sc-settings/Grade/GradeEdit';

import SecurazeAPI from '../sc-settings/SecurazeAPI';
import ApiKeyCreate from '../sc-settings/SecurazeAPI/ApiSetup/ApiKeyCreate';
import ApiKeyEdit from '../sc-settings/SecurazeAPI/ApiSetup/ApiKeyEdit';

import TypicalProblemCreate from '../sc-settings/TypicalProblem/TypicalProblemCreate';
import TypicalProblemEdit from '../sc-settings/TypicalProblem/TypicalProblemEdit';

import Printer from '../sc-settings/Printer';
import PrinterCreate from '../sc-settings/Printer/PrinterCreate';
import PrinterEdit from '../sc-settings/Printer/PrinterEdit';

import LogoCreate from '../sc-settings/Logo/LogoCreate';
import LogoEdit from '../sc-settings/Logo/LogoEdit';

import MediaUpload from '../sc-media/MediaGallery/MediaUpload.js';

import FilePatternEdit from '../sc-settings/FilePattern/FilePatternEdit';
import FilePatternCreate from '../sc-settings/FilePattern/FilePatternCreate';

import ReportDataCreate from '../sc-settings/ReportData/ReportDataCreate';
import ReportDataEdit from '../sc-settings/ReportData/ReportDataEdit';

import SKU from '../sc-settings/SKU';

import SKUPatternCreate from '../sc-settings/SKUPattern/SKUPatternCreate';
import SKUPatternEdit from '../sc-settings/SKUPattern/SKUPatternEdit';

import SKUMappingCreate from '../sc-settings/SKUMapping/SKUMappingCreate';
import SKUMappingEdit from '../sc-settings/SKUMapping/SKUMappingEdit';
import SKUMappingUpload from '../sc-settings/SKUMapping/SKUMappingUpload';

import ChassisTypeCreate from '../sc-settings/ChassisType/ChassisTypeCreate';
import ChassisTypeEdit from '../sc-settings/ChassisType/ChassisTypeEdit';

import NotificationSetting from '../sc-settings/NotificationSetting';
import NotificationSettingCreate from '../sc-settings/NotificationSetting/NotificationSettingCreate';
import NotificationSettingEdit from '../sc-settings/NotificationSetting/NotificationSettingEdit';

// import Mail from '../sc-settings/Mail';
import DeviceDependentSetting from '../sc-admin/DeviceDependentSetting';
import DeviceDependentSettingCreate from '../sc-admin/DeviceDependentSetting/DeviceDependentSettingCreate';
import DeviceDependentSettingEdit from '../sc-admin/DeviceDependentSetting/DeviceDependentSettingEdit';
import DeviceDependentSettingCreateFromThis from '../sc-admin/DeviceDependentSetting/DeviceDependentSettingCreateFromThis';
import DeviceDependentSettingUpload from '../sc-admin/DeviceDependentSetting/DeviceDependentSettingUpload';
// sc-palettes

import TransportColliDetails from '../sc-palette/Details/index';
import TransportColli from '../sc-palette/TransportColli';
import TransportColliCreate from '../sc-palette/TransportColli/TransportColliCreate';

import UnpairedPalette from '../sc-palette/UnpairedPalette';
import UnpairedPaletteCreateFromExternal from '../sc-palette/UnpairedPalette/UnpairedPaletteCreateFromExternal';
import UnpairedPaletteAssignToExisting from '../sc-palette/UnpairedPalette/UnpairedPaletteAssignToExisting';

import { hasExternalSettingsAvailable } from '../sc-utilities';
// sc-products
import PCProduct from '../sc-product/PCProduct/index';
import MobileProduct from '../sc-product/MobileProduct/index';
import StorageProduct from '../sc-product/StorageProduct';
import DisplayProduct from '../sc-product/DisplayProduct';
// import DisplayDiagnose from '../sc-product/Diagnose/DiagnoseDetails';
// import DisplayDiagnosePairs from '../sc-product/Diagnose/DiagnoseDetailsPairs/index';
import ProductHistories from '../sc-product/ProductHistories';
import ProductDetailsMobile from '../sc-product/MobileProduct/MobileProductDetails';
import ProductDetailsStorage from '../sc-product/StorageProduct/StorageProductDetails';
import ProductDetailsPC from '../sc-product/PCProduct/PCProductDetails';

import UnpairedProduct from '../sc-product/UnpairedProduct';
import UnpairedProductAssignToExisting from '../sc-product/UnpairedProduct/UnpairedProductAssignToExisting';
import StorageCreate from '../sc-productComponents/Storage/StorageCreate';
import StorageEdit from '../sc-productComponents/Storage/StorageEdit';
import MemoryCreate from '../sc-productComponents/Memory/MemoryCreate';
import MemoryEdit from '../sc-productComponents/Memory/MemoryEdit';
import CPUCreate from '../sc-productComponents/CPU/CPUCreate';
import CPUEdit from '../sc-productComponents/CPU/CPUEdit';
import NICCreate from '../sc-productComponents/NIC/NICCreate';
import NICEdit from '../sc-productComponents/NIC/NICEdit';
import BatteryCreate from '../sc-productComponents/Battery/BatteryCreate';
import BatteryEdit from '../sc-productComponents/Battery/BatteryEdit';
import BaseboardCreate from '../sc-productComponents/Baseboard/BaseboardCreate';
import BaseboardEdit from '../sc-productComponents/Baseboard/BaseboardEdit';
import GPUCreate from '../sc-productComponents/GPU/GPUCreate';
import GPUEdit from '../sc-productComponents/GPU/GPUEdit';
//sc-roles
import Roles from '../sc-roles/Roles';
import RolesCreate from '../sc-roles/Roles/RoleCreate';
import RoleEdit from '../sc-roles/Roles/RoleEdit'
//sc-importExport
import OldSecurazeData from '../sc-exportImport/OldSecurazeData';
import SecurazeCloudData from '../sc-exportImport/SecurazeCloudData';
//sc-billing
import BillingAccount from '../sc-billing/BillingAccount';
import BillingAccountOverview from '../sc-billing/BillingAccount/Details';
import BillingPlan from '../sc-billing/BillingPlan';
import BillingAccountCreate from '../sc-billing/BillingAccount/BillingAccountCreate';
import BillingAccountEdit from '../sc-billing/BillingAccount/BillingAccountEdit';
import SoftwareLicenseCreate from '../sc-billing/BillingAccount/Details/SoftwareLicense/SoftwareLicenseCreate'
import SoftwareLicenseEdit from '../sc-billing/BillingAccount/Details/SoftwareLicense/SoftwareLicenseEdit'
import PrePaidPlanCreate from '../sc-billing/BillingAccount/Details/PrePaid/PrePaidPlanCreate'
//st-download
import BinaryImageType from '../sc-download/BinaryImageType';
import BinaryImageTypeCreate from '../sc-download/BinaryImageType/BinaryImageTypeCreate';
import BinaryImageTypeEdit from '../sc-download/BinaryImageType/BinaryImageTypeEdit';


import SecurazeTool from '../sc-download/SecurazeTool';
import SecurazeToolCreate from '../sc-download/SecurazeTool/SecurazeToolCreate';
import SecurazeToolEdit from '../sc-download/SecurazeTool/SecurazeToolEdit';

import BinaryImages from '../sc-download/BinaryImages';
import BinaryImagesCreate from '../sc-download/BinaryImages/BinaryImageCreate';
import BinaryImagesEdit from '../sc-download/BinaryImages/BinaryImageEdit';

// sc-networkZone
import NetworkZone from '../sc-networkZone/NetworkZone';
import NetworkZoneCreate from '../sc-networkZone/NetworkZone/NetworkZoneCreate';
import NetworkZoneEdit from '../sc-networkZone/NetworkZone/NetworkZoneEdit';

import CustomerErasureMethod from '../sc-customerErasureMethod/CustomerErasureMethod';
import CustomerErasureMethodEdit from '../sc-customerErasureMethod/CustomerErasureMethod/CustomerErasureMethodEdit';

import ActiveCustomer from "../sc-activeCustomer/ActiveCustomer";

//sc-trialVouchers
import TrialVoucher from '../sc-trialVoucher/TrialVoucher';
import TrialVoucherEdit from '../sc-trialVoucher/TrialVoucher/TrialVoucherEdit';
import TrialVoucherCreate from '../sc-trialVoucher/TrialVoucher/TrialVoucherCreate';

import EmailVerification from '../sc-trialVoucher/CustomerRegistration/EmailVerification';
import CustomerRegistration from '../sc-trialVoucher/CustomerRegistration/CustomerRegistration';
import UserActivity from '../sc-dashboard/UserActivity';

// sc-logistic
import Warehouse from '../sc-warehouses/Warehouse';
import WarehouseCreate from '../sc-warehouses/Warehouse/WarehouseCreate';
import WarehouseEdit from '../sc-warehouses/Warehouse/WarehouseEdit';

import SupportedClientType from '../sc-admin/SupportedClientType';
import SupportedClientTypeCreate from '../sc-admin/SupportedClientType/SupportedClientTypeCreate';
import SupportedClientTypeEdit from '../sc-admin/SupportedClientType/SupportedClientTypeEdit';

import Colli from '../sc-logistic/Colli';
import ColliCreate from '../sc-logistic/Colli/ColliCreate';
import ColliEdit from '../sc-logistic/Colli/ColliEdit';
import ColliDelete from '../sc-logistic/Colli/ColliDelete';

import ColliType from '../sc-logistic/ColliType';
import ColliTypeCreate from '../sc-logistic/ColliType/ColliTypeCreate';

import ColliTypeEdit from '../sc-logistic/ColliType/ColliTypeEdit';

import ColliHistory from '../sc-logistic/ColliHistory';


// sc-tableView

import TableViewSystem from '../sc-tableView/TableView';
import TableViewSystemCreate from '../sc-tableView/TableView/TableViewCreate';
import TableViewSystemEdit from '../sc-tableView/TableView/TableViewEdit';

//CLIENT

import Client from '../Assets/sc-client/Clients';
import ClientCreate from '../Assets/sc-client/Clients/ClientCreate';
import ClientEdit from '../Assets/sc-client/Clients/ClientEditDetails';

//CLIENT ORGANIZATIONAL

import ClientOrganizational from '../Assets/sc-client/ClientOrganizational';
import ClientOrganizationalCreate from '../Assets/sc-client/ClientOrganizational/ClientOrganizationalUnitCreate';
import ClientOrganizationalEdit from '../Assets/sc-client/ClientOrganizational/ClientOrganizationalUnitEdit';

//Address

import Address from '../Assets/sc-client/Address';
import AddressCreate from '../Assets/sc-client/Address/AddressCreate';
import AddressEdit from '../Assets/sc-client/Address/AddressEdit';

//Contact

import Contact from '../Assets/sc-client/Contact';
import ContactCreate from '../Assets/sc-client/Contact/ContactCreate';
import ContactEdit from '../Assets/sc-client/Contact/ContactEdit';

import WorkManual from '../sc-manuals-page/Work';
import WorkVerifierManual from '../sc-manuals-page/WorkVerifier.js';
import MobileManual from '../sc-manuals-page/Mobile';
import RemoteManual from '../sc-manuals-page/Remote';

//Project

import Project from '../Assets/sc-client/Projects';
import ProjectCreate from '../Assets/sc-client/Projects/ProjectCreate';
import ProjectEdit from '../Assets/sc-client/Projects/ProjectEditDetails';
import GeneralPresets from '../sc-settings/Presets/General/index.js';
import WorkPresets from '../sc-settings/Presets/Work/index.js';
import WorkVerifierPresets from '../sc-settings/Presets/WorkVerifier/index.js';
import MobilePresets from '../sc-settings/Presets/Mobile/index.js';
import StoragePresets from '../sc-settings/Presets/Storage/index.js';
import InstalledSoftware from '../sc-settings/InstalledSoftware';
import ReportCustomization from '../sc-settings/ReportCustomization';
import Account from "../sc-accountManagement/Account"

// Download Page
import Work from '../sc-download-page/Work.js';
import Mobile from '../sc-download-page/Mobile.js';
import Command from '../sc-download-page/Command.js';
import Motion from '../sc-download-page/Motion.js';
import USBCreatorTool from '../sc-download-page/USBCreatorTool.js';
import Remote from '../sc-download-page/Remote.js';
import WorkVerifier from '../sc-download-page/WorkVerifier.js';

// Top UP
import TopUpCreate from '../sc-accountManagement/PrepaidBalance/Topup/TopUpCreate';
import TopupHistory from '../sc-accountManagement/PrepaidBalance/Topup/TopupHistory';
import PlanCreate from "../sc-billing/BillingPlan/PlanCreate";
import PlanEdit from "../sc-billing/BillingPlan/PlanEdit";

import SecurazeSolution from "../sc-admin/SecurazeSolution";
import SecurazeSolutionDetails from "../sc-admin/SecurazeSolution/SecurazeSolutionDetails";
import PlanVersions from "../sc-billing/BillingPlan/PlanVersions";
import Group from "../sc-group/Group";
import GroupDetails from "../sc-group/Group/GroupDetails";
import RaspberryEraseStationDetails from "../sc-dashboard/RaspberryEraseStation/RaspberryEraseStationDetails";

import DeviceDataApi from '../sc-settings/DeviceDataApi';
import DeviceDataApiCreate from '../sc-settings/DeviceDataApi/DeviceDataApiCreate';
import DeviceDataApiEdit from '../sc-settings/DeviceDataApi/DeviceDataApiEdit';

import AuthService from '../sc-settings/AuthService';
import AuthServiceCreate from '../sc-settings/AuthService/AuthServiceCreate';
import AuthServiceEdit from '../sc-settings/AuthService/AuthServiceEdit';

import ClientVersionsCheck from "../sc-admin/ClientVersionsCheck";
import QRCodeGenerator from "../sc-utilities/QRCodeGenerator";
import ControlMachineCreate from "../sc-dashboard/ControlMachine/ControlMachineCreate";
import CustomerDiagnoseCase from "../sc-settings/CustomerDiagnoseCase";
import CustomerDiagnoseCaseDetails from "../sc-settings/CustomerDiagnoseCase/CustomerDiagnoseCaseDetails";
import AdminDiagnoseCase from "../sc-admin/AdminDiagnoseCase";
import AdminDiagnoseCaseDetails from "../sc-admin/AdminDiagnoseCase/AdminDiagnoseCaseDetails";
import DeviceCaseSupported from '../sc-admin/DeviceCaseSupported';
import DeviceCaseSupportedDetails from '../sc-admin/DeviceCaseSupported/DeviceCaseSupportedDetails';
import DeviceCaseSupportedDiagnoseCases from '../sc-admin/DeviceCaseSupported/DeviceCaseSupportedDiagnoseCases';
import DeviceCaseSupportedDiagnoseDetails from "../sc-admin/DeviceCaseSupported/DeviceCaseSupportedDiagnoseCases/DeviceCaseSupportedDiagnoseDetails";
import DeviceCasePreselectionDiagnoseDetails from "../sc-admin/DeviceCasePreselection/DeviceCasePreselectionDiagnoseCases/DeviceCasePreselectionDiagnoseDetails.js";
import DeviceCasePreselection from '../sc-admin/DeviceCasePreselection';
import DeviceCasePreselectionDetails from '../sc-admin/DeviceCasePreselection/DeviceCasePreselectionDetails';
import DeviceCasePreselectionDiagnoseCases from '../sc-admin/DeviceCasePreselection/DeviceCasePreselectionDiagnoseCases/index.js';
import LabelTemplate from "../sc-settings/LabelTemplate";
import LabelTemplateDetails from "../sc-settings/LabelTemplate/LabelTemplateDetails";
import KPI from '../sc-dashboard/KPI';
import TypicalProblemUpload from '../sc-settings/TypicalProblem/TypicalProblemUpload';

const hasPermission = (permission, permissions) => {
    return permissions.includes(permission) || permissions.includes('*');
};

export const routes = (permissions) => (
    <Switch>
        <Route path={'/myProfile'} exact component={MyProfile} />
        <Route path={'/typical-problem-settings'} exact component={DefaultTypicalProblem} />

        {hasPermission('logistic_view', permissions) && <Route path={'/logistic/orders'} exact component={Order} /> }
        {hasPermission('logistic_view', permissions) && <Route path={'/order/details'} exact component={OrderDetails} /> }
        <Route path={'/order/create'} exact component={OrderCreate} />

        <Route path={'/account-management/users'} exact component={User} />

        <Route path={'/system/table-view'} exact component={TableViewSystem} />
        <Route path={'/system/table-view/Create'} exact component={TableViewSystemCreate} />
        <Route path={'/system/table-view/Edit'} exact component={TableViewSystemEdit} />
        <Route path={'/users/details'} component={UserDetails} />
        <Route path={'/users/create'} component={UserCreate} />
        {hasPermission('license_prototype', permissions) ?
            < Route path={'/billing/license-prototype'} exact component={LicensePrototype} /> : null}
        {hasPermission('license_prototype_create', permissions) ?
            < Route path={'/billing/license-prototype/create'} exact component={LicensePrototypeCreate} /> : null}
        {hasPermission('license_prototype_edit', permissions) ?
            < Route path={'/billing/license-prototype/edit'} exact component={LicensePrototypeEdit} /> : null}
        <Route path={'/account-management/account-details'} exact component={Account} />
        {hasPermission('access_all_customers', permissions) ? <Route path={'/admin/customers'} exact component={CustomerList} /> : null}
        {hasPermission('customer_load', permissions) ? <Route path={'/admin/customers/details'} exact component={CustomerEdit} /> : null}
        {hasPermission('customer_create', permissions) ? <Route path={'/admin/customers/create'} exact component={CustomerCreate} /> : null}
        {hasPermission('users_admin_settings', permissions) ? <Route path={'/admin/adminSettingsUsers'} exact component={UserAdminSettings} /> : null}
        <Route path={'/admin/errorLogs'} exact component={ErrorLog} />
        <Route path={'/admin/tableView'} exact component={TableView} />
        <Route path={'/admin/tableView/Create'} exact component={TableViewCreate} />
        <Route path={'/admin/tableView/Edit'} exact component={TableViewEdit} />
        {/* <Route path={'/admin' + '/rest'} exact component={RestClient} /> */}
        <Route path={'/settings/external-system-setting'} exact component={ExternalSystemSetting} />
        {hasPermission('external_system_setting_create', permissions) ? (
            <Route path={'/externalSystemSetting/create'} exact component={ExternalSystemSettingCreate} />
        ) : null}
        {hasPermission('external_system_setting_load', permissions) ? (
            <Route path={'/externalSystemSetting/edit'} exact component={ExternalSystemSettingEdit} />
        ) : null}
        <Route path={'/admin/sentMail'} exact component={SentMail} />
        <Route path={'/billing/deliveryNotes'} exact component={DeliveryNotes} />
        <Route path={'/admin/integrityChecks'} exact component={IntegrityCheck} />

        <Route path={'/admin/system-certificate'} exact component={SystemCertificate} />
        <Route path={'/admin/system-certificate/edit'} exact component={SystemCertificateEdit} />
        <Route path={'/admin/system-certificate/create'} exact component={SystemCertificateCreate} />


        <Route path={'/admin/translate'} exact component={Translate} />
        <Route path={'/admin/translate/create'} exact component={TranslateCreate} />
        <Route path={'/admin/translate/edit'} exact component={TranslateEdit} />
        <Route path={'/admin/translate/upload'} exact component={TranslationUpload} />
        <Route path={'/admin/grade-category'} exact component={GradingCategory} />
        {hasPermission('grading_category_create', permissions) ? (
            <Route path={'/admin/grade-category/create'} exact component={GradingCategoryCreate} />
        ) : null}
        {hasPermission('grading_category_load', permissions) ? (
            <Route path={'/admin/grade-category/edit'} exact component={GradingCategoryEdit} />
        ) : null}

        <Route path={'/admin/permissions'} exact component={Permission} />
        <Route path={'/admin/permission/create'} component={PermissionCreate} />
        <Route path={'/admin/permission/upload'} component={PermissionUpload} />
        <Route path={'/admin/permission/edit'} component={PermissionEdit} />

        {hasPermission('supported_client_type_list', permissions) ? (
            <Route path={'/admin/supported-client-types'} exact component={SupportedClientType} />
        ) : null}
        {hasPermission('supported_client_type_create', permissions) ? (
            <Route path={'/admin/supported-client-type/create'} exact component={SupportedClientTypeCreate} />
        ) : null}
        {hasPermission('supported_client_type_load', permissions) ? (
            <Route path={'/admin/supported-client-type/edit'} exact component={SupportedClientTypeEdit} />
        ) : null}

        {hasPermission('erasure_method_list', permissions) ? (
            <Route path={'/admin/erasureMethod'} exact component={ErasureMethod} />
        ) : null}
        {hasPermission('erasure_method_create', permissions) ? (
            <Route path={'/admin/erasureMethod/create'} exact component={ErasureMethodCreate} />
        ) : null}
        {hasPermission('erasure_method_load', permissions) ? (
            <Route path={'/admin/erasureMethod/edit'} exact component={ErasureMethodEdit} />
        ) : null}

        <Route path={'/reports/erasure-reports'} exact component={ErasureReportTabs} />
        {hasPermission("erasure_report_list", permissions) && <Route path={'/reports/diagnose-reports'} exact component={DiagnoseReport} />}
        {hasPermission("erasure_report_list", permissions) && <Route path={'/reports/verification-reports'} exact component={VerificationReport} />}

        <Route path={'/dashboard/asset-overview'} exact component={AllProducts} />

        <Route path={'/advanced/printer-queue'} exact component={PrintQueueList} />
        <Route path={'/admin/servers'} exact component={ServerInstanceList} />
        <Route path={'/dashboard/system-overview'} exact component={Overview} />

        <Route path={'/reports/user-reports'} exact component={Report} />
        <Route path={'/search'} exact component={Search} />
        {hasPermission('all_admin_asset_view', permissions) ? <Route path={'/dashboard/admin-asset-view'} exact component={Statistic} /> : null}
        <Route path={'/products/all-assets'} exact component={ProductOverview} />
        <Route path={'/advanced/user-activity'} exact component={UserActivity} />
        <Route path={'/dashboard/remote-access'} exact component={RemoteAssets} />
        <Route path={'/dashboard/upload-erasure-data'} exact component={UploadErasureData} />
        <Route path={'/dashboard/kpi-overview'} exact component={KPI} />

        <Route path={'/changeActiveCustomer'} exact component={ActiveCustomer} />

        <Route path={'/settings/operating-system/create'} component={OperatingSystemCreate} />
        <Route path={'/settings/operating-system/edit'} component={OperatingSystemEdit} />

        <Route path={'/settings/presets/general'} exact component={GeneralPresets} />
        <Route path={'/settings/presets/work'} exact component={WorkPresets} />
        <Route path={'/settings/presets/workVerifier'} exact component={WorkVerifierPresets} />
        <Route path={'/settings/presets/mobile'} exact component={MobilePresets} />
        <Route path={'/settings/presets/storage'} exact component={StoragePresets} />
        
        <Route path={'/settings/installed-software'} component={InstalledSoftware} />
        <Route path={'/settings/report-customization'} component={ReportCustomization} />
        <Route path={'/settings/sku'} component={SKU} />
        <Route path={'/settings/grading'} component={Grading} />

        <Route path={'/settings/grade/create'} component={GradeCreate} />
        <Route path={'/settings/grade/edit'} component={GradeEdit} />

        <Route path={'/settings/securaze-api'} exact component={SecurazeAPI} />
        {hasPermission('api_key_create', permissions) ? (
            <Route path={'/settings/securaze-api/create'} exact component={ApiKeyCreate} />
        ) : null}
        {hasPermission('api_key_load', permissions) ? (
            <Route path={'/settings/securaze-api/edit'} exact component={ApiKeyEdit} />
        ) : null}

        {hasPermission('control_machine_create', permissions) ? (
            <Route path={'/settings/create-offline-command'} exact component={ControlMachineCreate} />
        ) : null}

        <Route path={'/settings/typical-problem/create'} component={TypicalProblemCreate} />
        <Route path={'/settings/typical-problem/edit'} component={TypicalProblemEdit} />

        {hasPermission('raspberry_erase_station_load', permissions) && <Route path={'/settings/raspberry-erase-station/edit'} component={RaspberryEraseStationDetails} /> }

        <Route path={'/settings/printers'} component={Printer} />
        <Route path={'/settings/printer/create'} component={PrinterCreate} />
        <Route path={'/settings/printer/edit'} component={PrinterEdit} />

        <Route path={'/settings/logo/create'} component={LogoCreate} />
        <Route path={'/settings/logo/edit'} component={LogoEdit} />

        <Route path={'/settings/file-pattern/create'} component={FilePatternCreate} />
        <Route path={'/settings/file-pattern/edit'} component={FilePatternEdit} />

        <Route path={'/settings/report-data/create'} component={ReportDataCreate} />
        <Route path={'/settings/report-data/edit'} component={ReportDataEdit} />

        <Route path={'/settings/sku-pattern/create'} component={SKUPatternCreate} />
        <Route path={'/settings/sku-pattern/edit'} component={SKUPatternEdit} />

        <Route path={'/settings/sku-mapping/create'} component={SKUMappingCreate} />
        <Route path={'/settings/sku-mapping/edit'} component={SKUMappingEdit} />
        <Route path={'/settings/sku-mapping/upload'} component={SKUMappingUpload} />

        <Route path={'/settings/chassis-type/create'} component={ChassisTypeCreate} />
        <Route path={'/settings/chassis-type/edit'} component={ChassisTypeEdit} />

        <Route path={'/admin/notificationSettings'} component={NotificationSetting} />
        <Route path={'/settings/notificationSetting/create'} component={NotificationSettingCreate} />
        <Route path={'/settings/notificationSetting/edit'} component={NotificationSettingEdit} />

        {hasPermission('group_list', permissions) && <Route path={'/settings/group'} exact component={Group} /> }
        {hasPermission('group_create', permissions) && <Route path={'/settings/group/create'} exact component={GroupDetails} /> }
        {hasPermission('group_load', permissions) && <Route path={'/settings/group/edit'} exact component={GroupDetails} /> }

        <Route path={'/settings/device-data-api'} exact component={DeviceDataApi} />
        <Route path={'/settings/device-data-api/create'} exact component={DeviceDataApiCreate} />
        <Route path={'/settings/device-data-api/edit'} exact component={DeviceDataApiEdit} />

        {hasPermission('device_case_supported_list', permissions) && <Route path={'/admin/device-case-supported'} exact component={DeviceCaseSupported} /> }
        {hasPermission('system_device_case_supported_create', permissions) && <Route path={'/admin/device-case-supported/create'} exact component={DeviceCaseSupportedDetails} /> }
        {hasPermission('system_device_case_supported_load', permissions) && <Route path={'/admin/device-case-supported/update'} exact component={DeviceCaseSupportedDetails} /> }
        {hasPermission('system_device_case_supported_update_params', permissions) && <Route path={'/admin/device-case-supported/update-case-params'} exact component={DeviceCaseSupportedDiagnoseDetails} /> }
        {hasPermission('device_case_supported_list', permissions) && <Route path={'/admin/device-case-supported/diagnose'} exact component={DeviceCaseSupportedDiagnoseCases} /> }

        {hasPermission('device_case_preselection_list', permissions) && <Route path={'/admin/device-case-preselection'} exact component={DeviceCasePreselection} /> }
        {hasPermission('system_device_case_preselection_create', permissions) && <Route path={'/admin/device-case-preselection/create'} exact component={DeviceCasePreselectionDetails} /> }
        {hasPermission('system_device_case_preselection_load', permissions) && <Route path={'/admin/device-case-preselection/update'} exact component={DeviceCasePreselectionDetails} /> }
        {hasPermission('device_case_preselection_list', permissions) && <Route path={'/admin/device-case-preselection/diagnose'} exact component={DeviceCasePreselectionDiagnoseCases} /> } 
        
        {hasPermission('device_case_preselection_list', permissions) && <Route path={'/settings/device_case_preselection'} exact component={DeviceCasePreselection} /> }
        {hasPermission('device_case_preselection_create', permissions) && <Route path={'/settings/device_case_preselection/create'} exact component={DeviceCasePreselectionDetails} /> }
        {hasPermission('device_case_preselection_load', permissions) && <Route path={'/settings/device_case_preselection/update'} exact component={DeviceCasePreselectionDetails} /> }
        {hasPermission('device_case_preselection_list', permissions) && <Route path={'/settings/device_case_preselection/diagnose'} exact component={DeviceCasePreselectionDiagnoseCases} /> } 
        {hasPermission('device_case_preselection_update', permissions) && <Route path={'/settings/device-case-preselection/update-case-params'} exact component={DeviceCasePreselectionDiagnoseDetails} /> }

        <Route path={'/settings/auth-service'} exact component={AuthService} />
        <Route path={'/settings/auth-service/create'} exact component={AuthServiceCreate} />
        <Route path={'/settings/auth-service/edit'} exact component={AuthServiceEdit} />

        {hasPermission('label_template_list', permissions) && <Route path={'/settings/label-template'} exact component={LabelTemplate} /> }
        {hasPermission('label_template_create', permissions) && <Route path={'/settings/label-template/create'} exact component={LabelTemplateDetails} /> }
        {hasPermission('label_template_load', permissions) && <Route path={'/settings/label-template/edit'} exact component={LabelTemplateDetails} /> }


        {/* <Route path={'/settings/mails'} component={Mail} /> */}
        <Route path={'/admin/deviceDependentSettings'} component={DeviceDependentSetting} />
        <Route path={'/admin/deviceDependentSettingsCreate'} component={DeviceDependentSettingCreate} />
        <Route path={'/admin/deviceDependentSettingsEdit'} component={DeviceDependentSettingEdit} />
        <Route path={'/admin/deviceDependentSettingsCreateFromThis'} component={DeviceDependentSettingCreateFromThis} />
        <Route path={'/admin/deviceDependentSettingUpload'} component={DeviceDependentSettingUpload} />

        {hasPermission('logistic_view', permissions) && <Route path={'/logistic/transport-container'} exact component={TransportColli} /> }
        <Route path={'/palettes/transportColli/create'} exact component={TransportColliCreate} />

        {hasPermission('logistic_view', permissions) && <Route path={'/palettes/details'} exact component={TransportColliDetails} /> }

        {hasExternalSettingsAvailable() ? <Route path={'/unpairedAssets/unpairedPalette'} component={UnpairedPalette} /> : null}
        {hasExternalSettingsAvailable() ? <Route path={'/unpairedAssets/unpairedPalette-createFromExternal'} component={UnpairedPaletteCreateFromExternal} /> : null}
        {hasExternalSettingsAvailable() ? <Route path={'/unpairedAssets/unpairedPalette-assignToExisting'} component={UnpairedPaletteAssignToExisting} /> : null}

        <Route path={'/products/pc-products'} component={PCProduct} />
        <Route path={'/products/mobile-products'} component={MobileProduct} />
        <Route path={'/products/displayProducts'} component={DisplayProduct} />
        <Route path={'/products/storage-products'} component={StorageProduct} />
        {hasExternalSettingsAvailable() ? <Route path={'/unpairedAssets/unpairedProducts'} component={UnpairedProduct} /> : null}
        {hasExternalSettingsAvailable() ? <Route path={'/unpairedAssets/unpairedProducts-assignToExisting'} component={UnpairedProductAssignToExisting} /> : null}
        <Route path={'/product/histories'} component={ProductHistories} />
        <Route path={'/pc-product/details'} component={ProductDetailsPC} />
        <Route path={'/mobile-product/details'} component={ProductDetailsMobile} />
        <Route path={'/storage-product/details'} component={ProductDetailsStorage} />
        <Route path={'/storageDetails/create'} component={StorageCreate} />
        <Route path={'/storageDetails/edit'} component={StorageEdit} />
        <Route path={'/memoryDetails/create'} component={MemoryCreate} />
        <Route path={'/memoryDetails/edit'} component={MemoryEdit} />
        <Route path={'/cpuDetails/create'} component={CPUCreate} />
        <Route path={'/cpuDetails/edit'} component={CPUEdit} />
        <Route path={'/nicDetails/create'} component={NICCreate} />
        <Route path={'/nicDetails/edit'} component={NICEdit} />
        <Route path={'/batteryDetails/create'} component={BatteryCreate} />
        <Route path={'/batteryDetails/edit'} component={BatteryEdit} />
        <Route path={'/baseboardDetails/create'} component={BaseboardCreate} />
        <Route path={'/baseboardDetails/edit'} component={BaseboardEdit} />
        <Route path={'/gpuDetails/create'} component={GPUCreate} />
        <Route path={'/gpuDetails/edit'} component={GPUEdit} />

        <Route path={'/media/upload'} component={MediaUpload} />

        <Route path={'/account-management/roles'} exact component={Roles} />
        <Route path={'/roles/create'} component={RolesCreate} />
        <Route path={'/roles/edit'} component={RoleEdit} />

        <Route path={'/settings/customer-erasure-method'} exact component={CustomerErasureMethod} />
        <Route path={'/settings/customer-erasure-method/edit'} exact component={CustomerErasureMethodEdit} />
        <Route path={'/settings/typical-problem/upload'} exact component={TypicalProblemUpload} />


        {/* <Route path={'/session/compare'} exact component={DiagnoseSessionCompare} /> */}


        < Route path={'/admin/old-securaze-data'} exact component={OldSecurazeData} />
        < Route path={'/admin/securaze-cloud-data'} exact component={SecurazeCloudData} />

        {hasPermission('access_all_billing_accounts', permissions) ? <Route path={'/billing/accounts'} exact component={BillingAccount} /> : null}
        {hasPermission('billing_account_load', permissions) ? (
            <Route path={'/billing/accounts-overview'} exact component={BillingAccountOverview} />
        ) : null}
        {hasPermission('plan_list', permissions) ? <Route path={'/billing/plans'} exact component={BillingPlan} /> : null}
        {hasPermission('billing_account_create', permissions) ? (
            <Route path={'/billing/create'} exact component={BillingAccountCreate} />
        ) : null}
        {hasPermission('billing_account_load', permissions) ? (
            <Route path={'/billing/edit'} exact component={BillingAccountEdit} />
        ) : null}
        {hasPermission('billing_plan_create', permissions) ? (
            <Route path={'/billing/plans/create'} exact component={PlanCreate} />
        ) : null}
        {hasPermission('billing_plan_load', permissions) ? (
            <Route path={'/billing/plans/edit'} exact component={PlanEdit} />
        ) : null}
        {hasPermission('license_prototype_create', permissions) ? (
            <Route path={'/billing/software-license/create'} exact component={SoftwareLicenseCreate} />
        ) : null}
        {hasPermission('license_prototype_load', permissions) ? (
            <Route path={'/billing/software-license/edit'} exact component={SoftwareLicenseEdit} />
        ) : null}
        {hasPermission('prepaid_create', permissions) ? (
            <Route path={'/billing/prepaid-plan/create'} exact component={PrePaidPlanCreate} />
        ) : null}

        {hasPermission('plan_versions_list', permissions) && <Route path={'/billing/plans/versions'} component={PlanVersions} /> }

        < Route path={'/downloads/binaryImageType'} exact component={BinaryImageType} />
        < Route path={'/downloads/binaryImageType/create'} exact component={BinaryImageTypeCreate} />
        < Route path={'/downloads/binaryImageType/edit'} exact component={BinaryImageTypeEdit} />

        < Route path={'/downloads/securazeTool'} exact component={SecurazeTool} />
        < Route path={'/downloads/securazeTool/create'} exact component={SecurazeToolCreate} />
        < Route path={'/downloads/securazeTool/edit'} exact component={SecurazeToolEdit} />

        < Route path={'/downloads/binary-images'} exact component={BinaryImages} />
        < Route path={'/downloads/binary-images/create'} exact component={BinaryImagesCreate} />
        < Route path={'/downloads/binary-images/edit'} exact component={BinaryImagesEdit} />

        <Route path={'/settings/network-zone'} exact component={NetworkZone} />
        <Route path={'/network-zone/edit'} exact component={NetworkZoneEdit} />
        <Route path={'/network-zone/create'} exact component={NetworkZoneCreate} />

        <Route path={'/billing/trial-vouchers'} exact component={TrialVoucher} />
        <Route path={'/billing/trial-vouchers/edit'} exact component={TrialVoucherEdit} />
        <Route path={'/billing/trial-vouchers/create'} exact component={TrialVoucherCreate} />

        {<Route path={'/trial/verification'} exact component={EmailVerification} />}
        {<Route path={'/trial/registration'} exact component={CustomerRegistration} />}



        {hasPermission('logistic_view', permissions) ? (
            <Route path={'/logistic/warehouses'} exact component={Warehouse} />
        ) : null}
        {hasPermission('warehouse_create', permissions) ? (
            <Route path={'/warehouse/create'} exact component={WarehouseCreate} />
        ) : null}
        {hasPermission('logistic_view', permissions) ? (
            <Route path={'/warehouses/edit'} exact component={WarehouseEdit} />
        ) : null}

        {hasPermission('logistic_view', permissions) ? (
            <Route path={'/logistic/container'} exact component={Colli} />
        ) : null}
        {hasPermission('colli_create', permissions) ? (
            <Route path={'/logistic/warehouse/create'} exact component={ColliCreate} />
        ) : null}
        {hasPermission('logistic_view', permissions) ? (
            <Route path={'/container/edit'} exact component={ColliEdit} />
        ) : null}
        {hasPermission('colli_delete', permissions) ? (
            <Route path={'/warehouse/delete'} exact component={ColliDelete} />
        ) : null}
        {hasPermission('colli_type_list', permissions) ? (
            <Route path={'/logistic/colli-type'} exact component={ColliType} />
        ) : null}
        {hasPermission('colli_type_create', permissions) ? (
            <Route path={'/colli-type/create'} exact component={ColliTypeCreate} />
        ) : null}
        {hasPermission('colli_type_load', permissions) ? (
            <Route path={'/colli-type/edit'} exact component={ColliTypeEdit} />
        ) : null}

        {hasPermission('colli_history_list', permissions) ? (
            <Route path={'/logistic/colli-history'} exact component={ColliHistory} />
        ) : null}

        {hasPermission('product_type_list', permissions) ? (
            <Route path={'/admin/product-type'} exact component={ProductType} />
        ) : null}
        {hasPermission('product_type_create', permissions) ? (
            <Route path={'/product-type/create'} exact component={ProductTypeCreate} />
        ) : null}
        {hasPermission('product_type_load', permissions) ? (
            <Route path={'/product-type/edit'} exact component={ProductTypeEdit} />
        ) : null}

        {hasPermission('client_list', permissions) ? (
            <Route path={'/client'} exact component={Client} />
        ) : null}
        {hasPermission('client_create', permissions) ? (
            <Route path={'/client/create'} exact component={ClientCreate} />
        ) : null}
        {hasPermission('client_load', permissions) ? (
            <Route path={'/client/edit'} exact component={ClientEdit} />
        ) : null}
        {hasPermission('client_organizational_unit_list', permissions) ? (
            <Route path={'/client-organizational-unit'} exact component={ClientOrganizational} />
        ) : null}
        {hasPermission('client_organizational_unit_create', permissions) ? (
            <Route path={'/client-organizational-unit/create'} exact component={ClientOrganizationalCreate} />
        ) : null}
        {hasPermission('client_organizational_unit_load', permissions) ? (
            <Route path={'/client-organizational-unit/edit'} exact component={ClientOrganizationalEdit} />
        ) : null}
        {hasPermission('address_list', permissions) ? (
            <Route path={'/address'} exact component={Address} />
        ) : null}
        {hasPermission('address_create', permissions) ? (
            <Route path={'/address/create'} exact component={AddressCreate} />
        ) : null}
        {hasPermission('address_load', permissions) ? (
            <Route path={'/address/edit'} exact component={AddressEdit} />
        ) : null}
        {hasPermission('contact_list', permissions) ? (
            <Route path={'/contact'} exact component={Contact} />
        ) : null}
        {hasPermission('contact_create', permissions) ? (
            <Route path={'/contact/create'} exact component={ContactCreate} />
        ) : null}
        {hasPermission('contact_load', permissions) ? (
            <Route path={'/contact/edit'} exact component={ContactEdit} />
        ) : null}
        {hasPermission('project_list', permissions) ? (
            <Route path={'/project'} exact component={Project} />
        ) : null}
        {hasPermission('project_create', permissions) ? (
            <Route path={'/project/create'} exact component={ProjectCreate} />
        ) : null}
        {hasPermission('project_load', permissions) ? (
            <Route path={'/project/edit'} exact component={ProjectEdit} />
        ) : null}

        <Route path={'/topup/create'} exact component={TopUpCreate} />
        <Route path={'/topup/history'} exact component={TopupHistory} />

        {hasPermission('securaze_solution_list', permissions) && <Route path={'/admin/securaze-solution'} exact component={SecurazeSolution} /> }
        {hasPermission('securaze_solution_create', permissions) && <Route path={'/admin/securaze-solution/create'} exact component={SecurazeSolutionDetails} /> }
        {hasPermission('securaze_solution_load', permissions) && <Route path={'/admin/securaze-solution/edit'} exact component={SecurazeSolutionDetails} /> }

        <Route path={'/download-page/work'} exact component={Work} />
        <Route path={'/download-page/mobile'} exact component={Mobile} />
        <Route path={'/download-page/command'} exact component={Command} />
        <Route path={'/download-page/motion'} exact component={Motion} />
        <Route path={'/download-page/creator'} exact component={USBCreatorTool} />
        <Route path={'/download-page/remote'} exact component={Remote} />
        <Route path={'/download-page/workVerifier'} exact component={WorkVerifier} />

        <Route path={'/manuals-page/work'} exact component={WorkManual} />
        <Route path={'/manuals-page/workVerifier'} exact component={WorkVerifierManual} />
        <Route path={'/manuals-page/mobile'} exact component={MobileManual} />
        <Route path={'/manuals-page/remote'} exact component={RemoteManual} />

        {hasPermission('client_type_usage', permissions) && <Route path={'/admin/client-types-usage'} exact component={ClientVersionsCheck} /> }

        {hasPermission('customer_diagnose_case_list', permissions) && <Route path={'/settings/customer-diagnose-case'} exact component={CustomerDiagnoseCase} /> }
        {hasPermission('customer_diagnose_case_load', permissions) && <Route path={'/settings/customer-diagnose-case/edit'} exact component={CustomerDiagnoseCaseDetails} /> }
        {hasPermission('customer_diagnose_case_update', permissions) && <Route path={'/settings/customer-diagnose-case/update-case-params'} exact component={DeviceCaseSupportedDiagnoseDetails} /> }

        {hasPermission('diagnose_case_list', permissions) && <Route path={'/admin/diagnose-case'} exact component={AdminDiagnoseCase} /> }
        {hasPermission('diagnose_case_load', permissions) && <Route path={'/admin/diagnose-case/edit'} exact component={AdminDiagnoseCaseDetails} /> }
        {hasPermission('diagnose_case_create', permissions) && <Route path={'/admin/diagnose-case/create'} exact component={AdminDiagnoseCaseDetails} /> }
        {hasPermission('diagnose_case_update', permissions) && <Route path={'/admin/diagnose-case/update-case-params'} exact component={DeviceCaseSupportedDiagnoseDetails} /> }

        {hasPermission('*', permissions) && <Route path={'/qr-code-test'} exact component={QRCodeGenerator} /> }

        <Route component={PageNotFound}></Route>


    </Switch>
);